import { starIcon } from "~/util/dom";

/* eslint-disable */
const DEF_PERCENT = 50;
const STARS_COUNT = 5;

export interface IStarBannerOptions {
	percentage?: number,
	stars?: number,
	space: number;
	size: number;
}

export default class StarsBanner {
	_opts: IStarBannerOptions;
	_size: number;
	_percInc: number;
	_dom: {
		container: HTMLDivElement;
	};
	_percentage: number;

	constructor(optsArg) {
		this._opts = Object.assign({
			space: 2, // [px]
			size: 16 // [px]
		}, optsArg);

		this._dom = {
			container: Mapy.Util.node("div", { className: "stars-banner" }) as HTMLDivElement,
		};
		this._size = this._opts.size;
		this._percInc = 100 / STARS_COUNT;
		this._percentage = this._getStartPercentage();

		this._build();
	}

	destroy() {
		this._dom.container.remove();
	}

	get container() {
		return this._dom.container;
	}

	set percentage(percent) {
		this._percentage = percent;
		this._build();
	}

	_getStartPercentage() {
		if (typeof this._opts.percentage === "number") {
			return this._opts.percentage;
		} else if (typeof this._opts.stars === "number") {
			return (this._opts.stars / STARS_COUNT * 100);
		} else {
			return DEF_PERCENT;
		}
	}

	_build() {
		let perc = this._percInc;

		this._dom.container.setAttribute("data-percent", Math.floor(this._percentage).toString());
		this._dom.container.innerHTML = "";

		for (let i = 0; i < STARS_COUNT; i++) {
			let starEl = this._getStarEl();
			starEl.style.marginLeft = `${i > 0 ? this._opts.space : 0}px`;

			if (this._percentage >= perc) {
				// cela
				starEl.classList.add("full");
				this._dom.container.appendChild(starEl);
			}
			else {
				// mozna cast hvezdy?
				let diff = perc - this._percentage;

				if (diff < this._percInc) {
					// obal
					let starCover = Mapy.Util.node("span", { className: "star-cover" });
					starCover.style.width = `${this._size}px`;
					starCover.style.height = `${this._size}px`;
					starCover.style.marginLeft = `${i > 0 ? this._opts.space : 0}px`;
					// prazdna
					starEl.style.marginLeft = `0px`;
					starCover.appendChild(starEl);
					// cast
					let innerStarCover = Mapy.Util.node("span", { className: "inner-star" });
					innerStarCover.style.height = `${this._size}px`;
					innerStarCover.style.width = `${((this._percInc - diff) / this._percInc * 100).toFixed(2)}%`;
					let innerStar = this._getStarEl();
					innerStar.classList.add("full");
					innerStarCover.appendChild(innerStar);
					starCover.appendChild(innerStarCover);
					this._dom.container.appendChild(starCover);
				}
				else {
					// prazdna
					this._dom.container.appendChild(starEl);
				}
			}

			perc += this._percInc;
		}
	}

	_getStarEl() {
		let starEl = starIcon();
		starEl.style.width = `${this._size}px`;
		starEl.style.height = `${this._size}px`;
		return starEl;
	}
}
